<template>
  <b-card class="bg-white rounded-xl px-2">
    <!-- <AddBannerPopup :isOpen="isPopupOpen" @close="togglePopup" /> -->
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Regulation Policies & Papers</h2>
      </div>
      <div class="flex items-center gap-4">
        <base-button
          outline
          class="px-6 py-1 mx-1"
          type="primary"
          @click="handleAdd"
        >
          <span class="btn-inner--text flex justify-between items-center"
            ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
          </span>
        </base-button>
      </div>
    </div>
    <RegulationTable />
  </b-card>
</template>

<script>
import RegulationTable from "./components/RegulationTable.vue";
import AddRegulationPopup from "./components/AddRegulationPopup.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      isPopupOpen: false,
    };
  },
  components: {
    RegulationTable,
    AddRegulationPopup,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addRegulationPolicy" });
    },
    async togglePopup(val = false) {
      this.isPopupOpen = val;
    },
  },
};
</script>
<style>
.txt-color {
  color: #4f0a4b;
}
</style>
